import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import FilterBarStyles from './Styles';
import General from './General';
import DefaultLink from './DefaultLink';
import FilterBarPreview from './FilterBarPreview';

class ThemeFilterBar extends Component {
    render() {
        return (
            <div className="ThemeFilterBar Theme-Content">
                <h1>FilterBar</h1>
                <div className="subpages-main-content">
                    <div className="col-xs-12">
                        <div className="spark-panel spark-mar-t-1 spark-panel-buttons row">
                            <div className="spark-panel__content col-xs-12">
                                <FilterBarPreview filterBarPreview={this.props} />
                            </div>
                            <div className="spark-panel__content col-xs-12 col-sm-5">
                                <FilterBarStyles
                                    id="theme-filterbar-primary-text"
                                    tagNameName="Primary Text"
                                    tagName="primaryText"
                                    sampleText="Primary Text"
                                    fontData={this.props.primaryText}
                                />
                                <br />
                            </div>
                            <div className="spark-panel__content col-xs-12 col-sm-3">
                                <DefaultLink
                                    id=""
                                    tagNameName="Link"
                                    tagName="defaultLink"
                                    fontData={this.props.defaultLink}
                                />
                            </div>
                            <div className="spark-panel__content col-xs-12 col-sm-3">
                                <General
                                    id=""
                                    tagNameName="Background Color"
                                    tagName="general"
                                    fontData={this.props.general}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

ThemeFilterBar.propTypes = {
    children: PropTypes.element
};

ThemeFilterBar.contextTypes = {
    store: PropTypes.object
};

const mapStateToProps = state => {
    return { ...state.app.data.theme.filterBar, ...state.theme.filterBar };
};

export default connect(mapStateToProps)(ThemeFilterBar);



// WEBPACK FOOTER //
// ./src/components/pages/theme/filterbar/index.js